import React, { useEffect, useState } from "react";
import MatchDetailTabs from "../../common/MatchDetailTabs";
import { linkName, processMyArr } from "../../../utils/generalLiveCenter";
import CricketMatchDetailHead from "../../common/CricketMatchDetailHead";

const CricketMatchHead = ({
  matchDetail,
  difference,
  sport,
  setDataId,
  setDataType,
  setHead,
  setLeagueId,
  dataClient,
  children,
  id,
  currentTab,
  websiteBaseUrl,
  dataPath,
  title,
  show_cricket_animation,
  socketUrl,
  channel,
  event,
}) => {
  const [clientHeadData, setClientHeadData] = useState(null);

  useEffect(() => {
    if (!dataClient) return;

    const container = document.querySelector(".microservice-cont");
    const dataAttr = container?.getAttribute("data-listingdata");

    if (dataAttr) {
      try {
        const parsed = JSON.parse(dataAttr)?.headData;
        setClientHeadData(parsed);
      } catch (error) {
        console.error("Failed to parse headData:", error);
      }
    }
  }, [dataClient]);

  const matchData = dataClient ? clientHeadData?.data : matchDetail?.data;
  const tabsData = dataClient ? clientHeadData?.tabs : matchDetail?.tabs;

  const referee = matchData?.match_official?.official?.name;
  const venue = matchData?.venue;

  return (
    <div className="detail_page">
      {title && <h1>{title}</h1>}

      <div className="detail_head">
        <CricketMatchDetailHead
          sport={sport}
          data={matchData}
          difference={difference}
          referee={referee}
          venue={venue}
          setDataId={setDataId}
          setDataType={setDataType}
          setHead={setHead}
          setLeagueId={setLeagueId}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
          dataClient={dataClient}
          show_cricket_animation={show_cricket_animation}
          socketUrl={socketUrl}
          channel={channel}
          event={event}
        />
        {dataClient && (
          <MatchDetailTabs
            tabs={processMyArr(tabsData) || []}
            id={id}
            currentTab={currentTab}
            websiteBaseUrl={websiteBaseUrl}
            dataPath={dataPath}
            name={`${linkName(matchData?.competitors?.htn)}-vs-${linkName(
              matchData?.competitors?.atn
            )}`}
            sport={sport}
          />
        )}
      </div>

      <div className="detail_page_tabs">{children}</div>
    </div>
  );
};

export default CricketMatchHead;
